import React from 'react';
import styles from './Background.module.css';

export default function Background() {
    return (
        <div className={styles.heroBg} aria-hidden="true">
            <div className={`${styles.blob} ${styles.blobYellow1}`} />
            <div className={`${styles.blob} ${styles.blobPurple1}`} />
            <div className={`${styles.blob} ${styles.blobPurple2}`} />
            <div className={`${styles.blob} ${styles.blobYellow2}`} />

            <div className={styles.circleWhite} />

            <div className={`${styles.blob} ${styles.blobPurple3}`} />
            <div className={`${styles.blob} ${styles.blobYellow3}`} />

            <div className={styles.overlayGrad} />
        </div>
    );
}
